var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',[_vm._v("津ICP备15007925号-2")]),_c('div',[_vm._v("Copyright 链接地址 "),_c('a',{attrs:{"href":"https://beian.miit.gov.cn/"}},[_vm._v("https://beian.miit.gov.cn/")])]),_c('div',[_vm._v("郑州码源信息技术有限公司")])])
}]

export { render, staticRenderFns }